import DeliveryOptionsStore from '../store/DeliveryOptionsStore';
import { fetchFromJson } from './fetchFromJson';

const db = new DeliveryOptionsStore('deliveryOptionsDb');

const updateCache = 'deliveryoption_updateCache';
const getUpdateCache = (data) => data.delivery_options;
const toast = 'Delivery Options Updated';
const entityName = 'deliveryOptions';

const withDeliveryOptions = (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});

export default withDeliveryOptions
